import React, { useEffect } from 'react';
import './ErrorModal.css';

const ErrorModal = ({ show, message, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="error-modal-overlay" onClick={onClose}>
      <div className="error-modal" onClick={(e) => e.stopPropagation()}>
        <div className="error-modal-icon">
          <i className="fas fa-exclamation-circle"></i>
        </div>
        <div className="error-modal-content">
          <h3 className="error-modal-title">حدث خطأ</h3>
          <p className="error-modal-subtitle">An error occurred</p>
          {message && <p className="error-modal-message">{message}</p>}
        </div>
        <button className="error-modal-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default ErrorModal;

